export class EmployeeModel {
    row_num: number
    employee_no: number
    employee_name: string
    username: string
    category: string
    active: string
    employee_password: string
    employee_ssn: string
    doctor_license_no: string
    date_terminated: string
    paid_hourly: string
    clinic: number
    license_state: string
    doctor_dea_no: string
    doctor_dps_no: string
    role: number
    page_number: number

    constructor(
        row_num: number,
        employee_no: number,
        employee_name: string,
        username: string,
        category: string,
        active: string,
        employee_password: string,
        employee_ssn: string,
        doctor_license_no: string,
        date_terminated: string,
        paid_hourly: string,
        clinic: number,
        license_state: string,
        doctor_dea_no: string,
        doctor_dps_no: string,
        role: number,
        page_number: number
    ) {
        this.row_num = row_num
        this.employee_no = employee_no
        this.employee_name = employee_name
        this.username = username
        this.category = category
        this.active = active
        this.employee_password = employee_password
        this.employee_ssn = employee_ssn
        this.doctor_license_no = doctor_license_no
        this.date_terminated = date_terminated
        this.paid_hourly = paid_hourly
        this.clinic = clinic
        this.license_state = license_state
        this.doctor_dea_no = doctor_dea_no
        this.doctor_dps_no = doctor_dps_no
        this.role = role
        this.page_number = page_number
    }
}

export class EmployeeDDListModel {
    employee_no: number
    employee_name: string 
    category: string
    active: string

    constructor(
        employee_no: number,
        employee_name: string,
        category: string,
        active: string
    ) {
        this.employee_no = employee_no
        this.employee_name = employee_name
        this.category = category
        this.active = active
    }
}

export class EmployeeSearchModel {
    employee_no: number
    employee_name: string
    username: string
    role: number 

    constructor(
        employee_no: number,
        employee_name: string,
        username: string,
        role: number, 
    ) {
        this.employee_no = employee_no
        this.employee_name = employee_name
        this.username = username
        this.role = role 
    }
}